import { createSlice } from '@reduxjs/toolkit';
import { IUser } from 'Shared/Types';
import { getUserList, getUser, getCurrentUser } from './reducer';
import { RootState } from 'Redux/store';

interface UserState {
  userList?: IUser[];
  user?: IUser | null;
  currentUser?: IUser;
  error?: string | null;
  loading: boolean;
  success?: boolean;
}

const initialState: UserState = {
  loading: false,
  success: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clear(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    setUserToNull: (state) => {
      state.user = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUserList.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUserList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.userList = [];
    });
    builder.addCase(getUserList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.userList = action.payload;
    });

    builder.addCase(getUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.currentUser = undefined;
    });
    builder.addCase(getUser.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.user = action.payload;
    });

    builder.addCase(getCurrentUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCurrentUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.currentUser = undefined;
    });
    builder.addCase(getCurrentUser.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.currentUser = action.payload;
    });
  },
});

export const { clear, setUserToNull } = userSlice.actions;

export const selectUserLoading = (state: RootState) => state.user.loading;
export const selectUserError = (state: RootState) => state.user.error;
export const selectUserSuccess = (state: RootState) => state.user.success;
export const selectUserList = (state: RootState) => state.user.userList;
export const selectUser = (state: RootState) => state.user.user;
export const selectCurrentUser = (state: RootState) => state.user.currentUser;

export default userSlice;
